import { Module, VuexModule, getModule, Mutation, Action } from 'vuex-module-decorators';

import store from '@/store';
import { conduitApi } from '../api';
import { Meta, Response, ResponseSingle, Query, ULID } from '../models';

@Module({
	namespaced: true,
	name: 'plans',
	store,
	dynamic: true
})
class PlansModule extends VuexModule {
	@Action({ rawError: true })
	async getPlans(): Promise<ResponseSingle> {
		try {
			const response = await conduitApi.get(`/plans`);
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	@Action({ rawError: true })
	async getProducts(): Promise<ResponseSingle> {
		try {
			const response = await conduitApi.get(`/products`);
			return response.data;
		} catch (error) {
			throw error;
		}
	}
}

export default getModule(PlansModule);
